import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../Core/Image';

export const GalleryWrapper = styled.div`
  overflow: hidden;
`;

export const AnimationWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  margin: 0 -1rem;
  animation: ${({ images }) => `ticker ${3.5 * images}s linear infinite`};

  &:hover {
    animation-play-state: paused;
  }

  @keyframes ticker {
    0% {
      transform: translate3d(0, 0, 0);
    }

    100% {
      transform: ${({ images }) =>
        `translate3d(${-(13.25 + 1) * images}rem, 0, 0)`};
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 0 -1.25rem;

    @keyframes ticker {
      0% {
        transform: translate3d(0, 0, 0);
      }

      100% {
        transform: ${({ images }) =>
          `translate3d(${-(16 + 1.25) * images}rem, 0, 0)`};
      }
    }
  }
`;

export const ImgWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  min-width: 13.25rem;
  min-height: 13.25rem;
  border-radius: 1rem;
  margin: 0 0.5rem;

  &:nth-child(even) {
    background-color: ${themeGet('colors.velvet', '#3D1952')};
  }

  &:nth-child(odd) {
    background-color: ${themeGet('colors.pink', '#F9BBB4')};
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    min-width: 16rem;
    min-height: 16rem;
    margin: 0 0.625rem;
    border-radius: 1.25rem;
  }
`;

export const GalleryImage = styled(Image)`
  width: 9.625rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 12.375rem;
  }
`;

export const PausePlayBtn = styled.button`
  height: 12.5px;
  width: 12.5px;
  margin-bottom: 0.5rem;
  color: ${themeGet('colors.main-text', '#2B2C32')};

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 15px;
    width: 15px;
  }

  span {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;
